import { marked } from 'marked'
import { Link } from 'react-router'
import { getEventImgSrc } from '#app/utils/misc.tsx'

export function EventCard({
	event,
}: {
	event: {
		id: string
		title: string
		description: string
		ctaText: string | null
		ctaUrl: string | null
		dates: Array<{ id: string; date: Date | string; endDate: Date | string | null; label: string | null }>
		images: Array<{
			id: string
			objectKey: string
			altText: string | null
		}>
	}
}) {
	return (
		<div className="m-4 rounded-lg bg-white p-6">
			<h3 className="py-3 text-2xl font-semibold uppercase leading-6 tracking-wide text-ebhs-blue">
				{event.title}
			</h3>

			{event.dates.length > 0 ? (
				<div className="mb-4 text-sm text-gray-600">
					{event.dates.map((d) => (
						<div key={d.id}>
							{new Date(d.date).toLocaleDateString('en-US', {
								weekday: 'long',
								month: 'long',
								day: 'numeric',
								year: 'numeric',
								timeZone: 'UTC',
							})}
							{' — '}
							{new Date(d.date).toLocaleTimeString('en-US', {
								hour: 'numeric',
								minute: '2-digit',
								timeZone: 'UTC',
							})}
							{d.endDate
								? ` to ${new Date(d.endDate).toLocaleTimeString('en-US', {
										hour: 'numeric',
										minute: '2-digit',
										timeZone: 'UTC',
									})}`
								: ''}
							{d.label ? ` - ${d.label}` : ''}
						</div>
					))}
				</div>
			) : null}

			{event.images.length > 0 ? (
				<div className="mb-4 flex flex-wrap gap-4">
					{event.images.map((image) => (
						<img
							key={image.id}
							src={getEventImgSrc(image.objectKey)}
							alt={image.altText ?? ''}
							className="w-full rounded-lg"
						/>
					))}
				</div>
			) : null}

			<div
				className="prose max-w-none px-4"
				dangerouslySetInnerHTML={{
					__html: marked.parse(event.description, {
						async: false,
					}) as string,
				}}
			/>

			{event.ctaText && event.ctaUrl ? (
				<div className="mt-4 px-4">
					{event.ctaUrl.startsWith('/') ? (
						<Link
							to={event.ctaUrl}
							className="inline-flex items-center rounded-md bg-ebhs-blue px-6 py-3 text-lg font-semibold text-white shadow-sm hover:bg-ebhs-blue-dark"
						>
							{event.ctaText}
						</Link>
					) : (
						<a
							href={event.ctaUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="inline-flex items-center rounded-md bg-ebhs-blue px-6 py-3 text-lg font-semibold text-white shadow-sm hover:bg-ebhs-blue-dark"
						>
							{event.ctaText}
						</a>
					)}
				</div>
			) : null}
		</div>
	)
}
